import "@fontsource/noto-sans-jp"
import "@fontsource/noto-serif-jp"
import logo from "/src/images/common/logo.png"
import "./src/styles/base.css"
import "./src/styles/blog-contents-style.css"
import React, { useState, useEffect } from "react"


/* ------------------------------
   フェードアニメーション
------------------------------ */

export const onRouteUpdate = () => {

  /* ------------------------------
   * フェード系
   * ------------------------------ */
  if ("IntersectionObserver" in window) {
    const elements = document.querySelectorAll(
      ".fadeInUp, .fadeInRight, .fadeInLeftToRight"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("on");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    elements.forEach((el) => observer.observe(el));
  }

}

/* ------------------------------
   ローディング
------------------------------ */

export const onClientEntry = () => {
  if (typeof document === "undefined") return

  if (window.location.pathname !== "/") return

  document.documentElement.classList.add("js")

  const loader = document.createElement("div")
  loader.className = "loader"

  const inner = document.createElement("div")
  inner.className = "loaderInner"

  /* ロゴ */
  const logoImg = document.createElement("img")
  logoImg.src = logo
  logoImg.className = "logo"
  logoImg.alt = "company logo"

  inner.appendChild(logoImg)
  loader.appendChild(inner)
  document.body.appendChild(loader)

  /* アニメーション */
  setTimeout(() => {
    logoImg.classList.add("show")
  }, 500)

  setTimeout(() => {
    loader.classList.add("hide")
  }, 2500)

  setTimeout(() => {
    loader.remove()
    document.body.classList.add("loaded")
  }, 3500)
}